interface CTASectionProps {
  onRequestDemo: () => void;
}

const CTASection = ({ onRequestDemo }: CTASectionProps) => {
  const scrollToAudit = () => {
    document.getElementById("audit-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 px-8">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-primary to-primary-container p-16 rounded-[3rem] text-center text-on-primary relative overflow-hidden shadow-2xl">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />

        <div className="relative z-10">
          <h2 className="font-headline text-4xl font-extrabold mb-6">
            Your Competitors Are Already Optimizing for AI Search.
          </h2>
          <p className="text-on-primary/80 text-lg mb-10 max-w-xl mx-auto">
            Every day you wait, another hotel is capturing the AI recommendations you should be
            getting. Run your free audit now and see exactly where you stand.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={scrollToAudit}
              className="bg-on-primary text-primary px-10 py-4 rounded-xl font-bold text-lg hover:bg-inverse-on-surface transition-colors"
            >
              Start Your Audit
            </button>
            <button
              onClick={onRequestDemo}
              className="border border-on-primary/30 text-on-primary px-10 py-4 rounded-xl font-bold text-lg hover:bg-on-primary/10 transition-colors"
            >
              Talk to an Expert
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
